import parsePhoneNumber from 'libphonenumber-js';

const parasePhoneNumber = (phoneNumber) => {
    const parasedPhoneNumber = parsePhoneNumber(phoneNumber, 'ET');

    return parasedPhoneNumber.number;
}

export default parasePhoneNumber;